import { useMutation, useLazyQuery } from '@apollo/client/react';
import {
  REQUEST_OTP_MUTATION,
  VERIFY_OTP_MUTATION,
  RESET_PASSWORD_MUTATION,
} from '@jwp/ott-common/src/graphql/mutation/auth.mutation';
import { SEND_USER_RECOVERY_MAIL_QUERY, MEET_SIGN_IN_QUERY, MeetSignInResponse, GET_ACCESS_TOKEN_QUERY, GetAccessTokenResponse } from '@jwp/ott-common/src/graphql/query/auth.query';
import { getPublicApolloClient } from '@jwp/ott-common/src/graphql/ApolloClient';
import { PATH_SIGN_IN } from '@jwp/ott-common/src/paths';
import env from '@jwp/ott-common/src/env';

export const useAuth = () => {
  const publicClient = getPublicApolloClient();

  const [requestOTPMutation, { loading: requestOTPLoading, error: requestOTPError, data: requestOTPData }] = useMutation(REQUEST_OTP_MUTATION, { client: publicClient });
  const [verifyOTPMutation, { loading: otpVerifyLoading, error: otpVerifyError }] = useMutation(VERIFY_OTP_MUTATION, { client: publicClient });
  const [resetPasswordMutation, { loading: resetPasswordLoading, error: resetPasswordError }] = useMutation(RESET_PASSWORD_MUTATION, { client: publicClient });
  
  const [sendUserRecoveryMailQuery, { loading: recoveryLoading, error: recoveryError }] = useLazyQuery(SEND_USER_RECOVERY_MAIL_QUERY, {
    client: publicClient,
    fetchPolicy: 'network-only',
  });

  const [meetSignInQuery, { loading: signInLoading, error: signInError }] = useLazyQuery<MeetSignInResponse>(MEET_SIGN_IN_QUERY, {
    client: publicClient,
    fetchPolicy: 'network-only',
  });

  const requestOTP = async (email: string) => {
    return await requestOTPMutation({ 
      variables: { email, source: 'play' },
    });
  };

  const OTPVerify = async (code: string, email: string) => {
    return await verifyOTPMutation({ 
      variables: { code, email },
    });
  };

  const recoveryMyUsername = async (emailId: string) => {
    return await sendUserRecoveryMailQuery({ 
      variables: { emailId, source: 'play' },
    });
  };

  const resetPassword = async (code: string, email: string, newPassword: string) => {
    return await resetPasswordMutation({ 
      variables: { code, email, newPassword },
    });
  };

  const signIn = async (input: any) => {
    const uri = env.APP_API_GRAPHQL_ENDPOINT || env.APP_GRAPHQL_ENDPOINT || 'https://meet.katon360.com/api/graphql';
    
    return await meetSignInQuery({
      variables: { input },
      context: { uri },
    });
  };

  const meetSignIn = signIn;

  return {
    requestOTP,
    requestOTPLoading,
    requestOTPError,
    requestOTPData,
    OTPVerify,
    otpVerifyError,
    otpVerifyLoading,
    recoveryLoading,
    recoveryError,
    recoveryMyUsername,
    resetPassword,
    resetPasswordError,
    resetPasswordLoading,
    signIn,
    meetSignIn,
    signInLoading,
    signInError,
  };
};

export const refreshAccessToken = async (refreshToken: string) => {
  const publicClient = getPublicApolloClient();
  try {
    const response = await publicClient.query<GetAccessTokenResponse>({
      query: GET_ACCESS_TOKEN_QUERY,
      variables: { refreshToken },
      fetchPolicy: 'network-only',
    });
    return response?.data?.getaccessToken;
  } catch (error) {
    console.error('refreshAccessToken error:', error);
    return null;
  }
};

export const handleLogout = () => {
  localStorage.removeItem('jwapp.auth');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('inplayer_token');
  localStorage.removeItem('katon_user');
  window.location.href = PATH_SIGN_IN;
};
